import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import { LinkContainer } from "react-router-bootstrap";

function BasicExample() {
  return (
    <Navbar collapseOnSelect expand="lg" bg="light">
      <Container>
        <LinkContainer to="/">
          <Navbar.Brand href="#home">
            <img
              src="../img/logos/Logo_5.png"
              width="50"
              height="50"
              className="d-inline-block align-top"
              alt="React Bootstrap logo"
            />
          </Navbar.Brand>
        </LinkContainer>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <LinkContainer to="/">
              <Nav.Link>Home</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/about">
              <Nav.Link>THIS IS US</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/services">
              <Nav.Link>Oue Value</Nav.Link>
            </LinkContainer>
          </Nav>
          <Nav>
            <Button
              href="https://shop.hardworkdiscipline.com"
              target="_blank"
              variant="outline-primary"
            >
              Freedom Plan Store
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default BasicExample;
